import { BoxProps, Flex } from "@chakra-ui/react";
import { Children, ReactNode } from "react";
import cardVipBg from "@/assets/images/payment/card_vip_bg.png";

const normalGradient = `radial-gradient(ellipse at 0 100%, #315443 0% 0%, transparent 90% 40%), radial-gradient(ellipse at 80% 0, #304d67 20% 0, #6ABBF900 100%)`;
const vipGradient = `center / cover no-repeat url(${cardVipBg})`;

interface Props extends BoxProps {
  isVip: boolean;
  children?: ReactNode;
}

export default function GradientCard(props: Props) {
  const { isVip, children, ...boxProps } = props;
  return (
    <Flex
      h="90px"
      rounded="12px"
      justify="center"
      align="center"
      flexDirection="column"
      color="white"
      {...boxProps}
      bg={isVip ? vipGradient : normalGradient}
      pos="relative"
      overflow="hidden"
    >
      {children}
    </Flex>
  );
}
